import { h } from 'preact';
import { OrthomolIcon } from '~/components-common/OrthomolIcon';
import { URLS } from '~/components-shop/Urls';

interface TreuepunkteInfoProps {
  excludeFromLoyaltyPoints?: boolean;
}

export const TreuepunkteInfo = ({ excludeFromLoyaltyPoints = false }: TreuepunkteInfoProps) => {
  const treuepunkteInfoUrl = URLS.treuepunkte;

  // Don't display if excluded from loyalty points
  if (excludeFromLoyaltyPoints) {
    return null;
  }

  return (
    <div id="product-variant-additional-info-points" className="mx-1 d-flex align-items-center gap-3">
      <span className="text-primary">
        <OrthomolIcon name="present-24" />
      </span>
      <p className="mb-0">
        Für diesen Kauf erhältst Du <a href={treuepunkteInfoUrl}>Mein-Orthomol-Treuepunkte</a>
      </p>
    </div>
  );
};
